import { AuthRegisterPage } from '@/app/pages/auth/auth-register';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/auth/register')({
  validateSearch: z.object({
    redirectTo: z.string().optional(),
    travelId: z.string().uuid().optional(),
  }),
  component: AuthRegisterPage,
});
